<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add Teaser Line</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/teasertemplate/list" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createTeaserLine" v-if="teaserLine">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-12">
                                <fg-input type="text"
                                          v-model="teaserLine.messageText"
                                          label="Teaset Subject Line"
                                          placeholder="Enter Teaser Line"
                                          v-validate="rules.messageText"
                                          data-vv-name="messageText"
                                          cus-name="messageText"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-md-12">
                              <fg-input type="text"
                                        v-model="teaserLine.templateName"
                                        label="Page Name"
                                        placeholder="XXXXXX"
                                        v-validate="rules.templateName"
                                        data-vv-name="templateName"
                                        cus-name="templateName"
                                        :has-errors="errors"
                                        :is-fields="fields">
                              </fg-input>
                            </div>
                            <div class="col-3" v-if="status.length">
                              <fg-select
                                v-model="teaserLine.active"
                                label="isActive"
                                v-validate="rules.active"
                                data-vv-name="active"
                                cus-name="active"
                                :has-errors="errors"
                                :is-fields="fields"
                                :list="status"
                                selectedKey="id"
                              >
                              </fg-select>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Teaser Line
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'NewTeaserLine',
    data () {
        return {
            teaserLine: {
                messageText: '',
                templateName: 'TONE_TEASER_EMAIL',
                active: '1'
            },
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            rules: {
              teaserLine: {required : true},
              active: {required: true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
      createTeaserLine () {
          console.log("this.teaserLine : ", this.teaserLine);
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_TEASER_LINE', this.teaserLine)
                .then((res) => {
                  console.log("ADD_TEASER_LINE res : ", res);
                  if(res) this.showPopup('Success!', 'New Teaser Line is successfully added', 'success', ()=>this.$router.push('/admin/teasertemplate/list'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
              })
              .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_teaserLine API error : ", err);
              })
          }
        })
      },
      showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
      }
    },
    created() {
      // this.fetchCorporations();
    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Teaser/CreateTeaserLine.vue